import { SalesManagerShopItemCategory } from "@impacgroup/ayyildiz-checklist-platform-api-dtos";
import { Exclude, Type } from "class-transformer";
import { getSalesManagerItemCategoryI18N } from "../utils/itemcategories";

export class SalesManagerShopItem {
    _id?: string;

    name: string;
    materialNumber: string;
    category: SalesManagerShopItemCategory;
    maximumOrder?: number;
    inactive?: boolean;

    version?: number;

    @Type(() => Date)
    @Exclude({ toPlainOnly: true })
    created?: Date;

    @Type(() => Date)
    @Exclude({ toPlainOnly: true })
    updated?: Date;

    public getCategoryI18N(): string {
        return getSalesManagerItemCategoryI18N(this.category);
    }
}
